export default {
  // YouTube Link Generator
  'link.mainTitle': 'YouTube时间戳链接生成器',
  'link.mainTitleSEO': 'YouTube时间戳链接生成器 - 创建可分享的视频链接',
  'link.subtitle': '生成从特定时间开始的YouTube链接 - 完美用于分享',

  // Link Generator Tool
  'link.generatorTitle': '创建带时间戳的YouTube链接',
  'link.pasteUrl': '粘贴YouTube网址：',
  'link.urlPlaceholder': 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  'link.startTime': '开始时间：',
  'link.hours': '小时',
  'link.minutes': '分钟',
  'link.seconds': '秒',
  'link.orEnterSeconds': '或输入总秒数：',
  'link.secondsPlaceholder': '例如：90',

  // Output Section
  'link.generatedLinks': '生成的可分享链接：',
  'link.shortLink': '短链接（推荐）：',
  'link.fullLink': '完整链接：',
  'link.embedCode': '嵌入代码：',
  'link.preview': '预览：',
  'link.copyLink': '复制链接',
  'link.copyEmbed': '复制嵌入代码',

  // URL Formats
  'link.urlFormats': 'YouTube时间戳链接格式说明',
  'link.format1Title': '1. 查询参数格式 (?t=)',
  'link.format1Desc': '在任何YouTube链接后添加 ?t= 或 &t=：',
  'link.format1Example1': '?t=90 - 90秒（1分30秒）',
  'link.format1Example2': '?t=1m30s - 1分钟30秒',
  'link.format1Example3': '?t=1h5m30s - 1小时5分钟30秒',

  'link.format2Title': '2. 井号片段格式 (#t=)',
  'link.format2Desc': '较旧的格式，使用 #t=：',

  'link.format3Title': '3. 移动应用深度链接',
  'link.format3Desc': '用于移动设备分享：',

  'link.format4Title': '4. 嵌入网址的start参数',
  'link.format4Desc': '用于嵌入式视频：',

  // Use Cases
  'link.useCases': '使用时间戳链接的场景',
  'link.useCase1Title': '📱 社交媒体分享',
  'link.useCase1Desc': '在Twitter、Facebook、Reddit上分享精确时刻',

  'link.useCase2Title': '📧 邮件引用',
  'link.useCase2Desc': '向同事发送培训视频的特定部分',

  'link.useCase3Title': '📝 博客引用',
  'link.useCase3Desc': '在文章中链接到特定的视频证据',

  'link.useCase4Title': '💬 论坛讨论',
  'link.useCase4Desc': '在视频辩论中引用确切时刻',

  'link.useCase5Title': '🎓 教育内容',
  'link.useCase5Desc': '引导学生到特定的课程片段',

  'link.useCase6Title': '🎬 视频评论',
  'link.useCase6Desc': '突出显示特定的场景或时刻',

  // FAQ
  'link.faq': 'YouTube时间戳链接常见问题',

  'link.faq.q1': 'YouTube时间戳链接在移动设备上有效吗？',
  'link.faq.a1': '是的！?t= 和 #t= 两种格式在移动浏览器和YouTube应用中都有效。如果已安装应用，链接会在应用中打开，否则会在移动浏览器中打开。',

  'link.faq.q2': '可以在嵌入式视频中使用时间戳链接吗？',
  'link.faq.a2': '可以，在嵌入URL中使用 start= 参数：<iframe src="https://www.youtube.com/embed/VIDEO_ID?start=90"></iframe>',

  'link.faq.q3': '时间戳链接对YouTube Shorts有效吗？',
  'link.faq.a3': '不，YouTube Shorts目前不支持时间戳参数。时间戳链接只对常规YouTube视频有效。',

  'link.faq.q4': '时间戳链接会一直有效吗？',
  'link.faq.a4': '是的，只要视频保持公开和可访问状态，时间戳链接就会继续有效。如果视频被删除或设为私密，链接将无法使用。',

  'link.faq.q5': '可以在链接中添加结束时间吗？',
  'link.faq.a5': '可以，你可以添加 &end= 参数：?t=90&end=180 将从1:30播放到3:00',

  'link.faq.q6': '应该使用哪种格式 - ?t= 还是 #t=？',
  'link.faq.a6': '使用 ?t=（查询参数）格式。这是现代标准，在所有平台上都更可靠。#t= 格式较旧，兼容性较差。',

  // Related Tools
  'link.relatedTools': '相关YouTube工具',
  'link.needChapters': '需要创建视频章节？',
  'link.needChaptersDesc': '使用我们的YouTube时间戳生成器为视频描述和评论创建章节时间戳。',
  'link.checkGenerator': '查看YouTube时间戳生成器',

  'link.needUnixTime': '处理Unix时间戳？',
  'link.needUnixTimeDesc': '使用我们的时间戳转换器将Unix时间戳转换为可读日期。',

  // How to Use
  'link.howToUse': '如何创建YouTube时间戳链接',
  'link.step1': '复制YouTube视频URL',
  'link.step1Desc': '从浏览器地址栏或分享按钮获取URL',

  'link.step2': '输入开始时间',
  'link.step2Desc': '使用时间选择器或直接输入秒数',

  'link.step3': '复制你喜欢的链接格式',
  'link.step3Desc': '在短链接、完整链接或嵌入代码之间选择',

  'link.step4': '随处分享！',
  'link.step4Desc': '适用于社交媒体、邮件、论坛和消息应用',

  // Additional Tips
  'link.tips': '专业提示',
  'link.tip1': '💡 在社交媒体上使用短链接（youtu.be）- 更简洁，占用空间更少',
  'link.tip2': '💡 右键点击YouTube视频并选择"在当前时间复制视频网址"可快速分享',
  'link.tip3': '💡 时间戳也适用于播放列表：只需在播放列表URL后添加 &t=90',
  'link.tip4': '💡 可以与其他参数组合使用，如播放列表的 &list= 或 &autoplay=1',

  // YouTube Generator (用于第二个页面)
  'gen.mainTitle': 'YouTube时间戳生成器',
  'gen.mainTitleSEO': 'YouTube时间戳生成器 - 创建视频章节和评论时间戳',
  'gen.subtitle': '生成YouTube时间戳用于章节、评论和描述',

  // Generator Tool
  'gen.generatorTitle': '生成YouTube时间戳',
  'gen.chaptersTab': '视频章节',
  'gen.converterTab': '时间转换器',
  'gen.commentTab': '评论模板',

  // Chapters Builder
  'gen.chaptersBuilder': '视频章节生成器',
  'gen.addChapter': '+ 添加章节',
  'gen.timestamp': '时间戳',
  'gen.chapterName': '章节名称',
  'gen.copyToDescription': '复制到视频描述：',
  'gen.copyAll': '全部复制',

  // Time Converter
  'gen.converterTitle': '秒数转时间戳转换器',
  'gen.seconds': '秒数：',
  'gen.youtubeFormat': 'YouTube格式：',
  'gen.batchConvert': '批量转换：',
  'gen.enterSecondsMultiple': '输入秒数，每行一个：',
  'gen.convertAll': '全部转换',

  // Comment Template
  'gen.commentTemplate': '评论时间戳模板',
  'gen.commentPlaceholder': '精彩视频！重点时刻：\n0:00 开场\n1:23 主要观点\n5:45 总结',
  'gen.copyComment': '复制评论',

  // How to Use Timestamps
  'gen.howToUse': '如何使用YouTube时间戳（3种方法）',

  'gen.method1': '视频章节（描述）',
  'gen.requirements': '要求：',
  'gen.req1': '至少3个时间戳',
  'gen.req2': '第一个时间戳必须是 0:00',
  'gen.req3': '每个章节之间至少间隔10秒',
  'gen.example': '示例：',
  'gen.chaptersDisplay': '章节在视频播放器中的显示方式',

  'gen.method2': '评论时间戳',
  'gen.method2Desc': '在评论中输入时间戳 - YouTube会自动将其转换为链接！',
  'gen.formatRules': '格式规则：',
  'gen.rule1': '0:00 - 分钟:秒',
  'gen.rule2': '1:23:45 - 小时:分钟:秒',
  'gen.rule3': '时间戳前使用空格或换行',
  'gen.rule4': '可以在时间戳后添加描述',
  'gen.commentExample': '评论示例：',

  'gen.method3': '视频标题时间戳',
  'gen.method3Desc': '在视频标题中添加时间戳以突出关键时刻：',

  // Chapter Benefits
  'gen.benefits': '使用视频章节的好处',
  'gen.benefit1Title': '更好的分析',
  'gen.benefit1Desc': '查看观众最常观看的章节',

  'gen.benefit2Title': '改善SEO',
  'gen.benefit2Desc': '章节会出现在Google搜索结果中',

  'gen.benefit3Title': '更高的留存率',
  'gen.benefit3Desc': '观众可以跳转到相关部分',

  'gen.benefit4Title': '移动友好',
  'gen.benefit4Desc': '在小屏幕上轻松导航',

  // Creator Tips
  'gen.creatorTips': '创作者提示：优化时间戳',
  'gen.bestPractices': '章节命名最佳实践',
  'gen.practice1': '保持名称在40个字符以内',
  'gen.practice2': '使用关键词以提高SEO',
  'gen.practice3': '描述要简洁明了',
  'gen.practice4': '使用动作词（学习、发现、查看）',

  'gen.commonMistakes': '要避免的常见错误',
  'gen.mistake1': '❌ 第一章不从 0:00 开始',
  'gen.mistake2': '❌ 使用少于3个章节',
  'gen.mistake3': '❌ 章节间隔太近（<10秒）',
  'gen.mistake4': '❌ 使用通用名称如"第1部分"、"第2部分"',

  // Generator FAQ
  'gen.faq': 'YouTube时间戳生成器FAQ',

  'gen.faq.q1': '如何在YouTube描述中添加章节？',
  'gen.faq.a1': '在视频描述中添加至少3个时间戳，第一个必须是0:00，每个时间戳之间至少间隔10秒。YouTube会自动识别并创建章节。',

  'gen.faq.q2': '章节何时出现在我的视频中？',
  'gen.faq.a2': '章节在满足要求后立即出现。可能需要几分钟才能在所有平台上显示。',

  'gen.faq.q3': '可以编辑已发布视频的章节吗？',
  'gen.faq.a3': '可以！只需编辑视频描述并更新时间戳。更改会立即生效。',

  'gen.faq.q4': '章节适用于所有视频吗？',
  'gen.faq.a4': '章节适用于大多数视频，但YouTube Shorts和某些类型的内容可能不支持。',

  'gen.faq.q5': '可以添加多少个章节？',
  'gen.faq.a5': '没有官方限制，但建议使用5-15个章节以获得最佳用户体验。',
};
